module.exports = __webpack_public_path__ + "static/img/2.3db29d83.jpg";